<template>
  <div class="button-follower">
    <a  class="button-follower__button ff--ssi">
      Read
    </a>
  </div>
</template>

<script setup>

</script>

<style>
  .button-follower {
    position: relative;
  }
  .button-follower__button {
    font-size: 1.5rem;
    text-transform: uppercase;
    height: 9rem;
    width: 9rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid black;
  }
</style>